export default {"src":"/_next/static/media/icon-404-mobile.5247d356.svg","height":89,"width":196,"blurWidth":0,"blurHeight":0};